import './Calendar.scss';
import Control from "../../Control";
import NP from "../../NP";
import Delegate from "../../Delegate";
import ListBox, {ListBoxItemArgs} from "../ListBox/ListBox";
import Accordion from "../Accordion/Accordion";
import Button from "../Button/Button";
import IconToggleButton from "../IconToggleButton/IconToggleButton";
import "./../../../resources/en";

let moment = require('moment');

export default class Calendar extends Control {
	public EvDateChanged: Delegate;
	private _options: any;
	private _elements: any;
	private _events: any;
	private _selected: any;
	private _Min: any;
	private _Max: any;
	private _date: Date;
	private _target: HTMLElement;
	private _active: Date[];
	private _headtable: any;
	private _head: HTMLElement;
	private _mSubHeader: HTMLElement;
	private _mSep: HTMLElement;
	private _monthList: ListBox;
	private _yearList: Accordion;
	private _cancelMonthBtn: Button;
	private _listNode: HTMLElement;

	constructor(settings?: object)
	{
		super(settings);

		this._options = {
			zeroFill: false,
			monthFormat: 'month YYYY',
			dayFormat: 'DD',
			firstDayOfTheWeek: NP.getCurrentUser().getRegionalSettings().FirstDayOfWeek || 1,
			navigator: true,
			navigatorPosition: 'both'
		};

		this._elements = {};

		this._events = {};
		this._events.date = [];
		this._events.month = [];

		this._selected = [];


		this._setDate(this._Value || new Date());

		this._render();
		this._update();
	}

	_initFields(settings: object)
	{
		this.EvDateChanged = new Delegate();
		this._Min = moment().add(-50, 'year').toDate();
		this._Max = moment().add(10, 'year').toDate();
		super._initFields(settings);
	}


	// Check if date in range
	_isDateInRange(date: Date)
	{
		// If no range
		if (this._Min === false && this._Max === false)
		{
			return true;
		}

		// Parse date
		date = this._parseDate(date);

		// Check min
		if (this._Min !== false && this._Min.getTime() > date.getTime())
		{
			return false;
		}
		// Check max
		if (this._Max !== false && this._Max.getTime() < date.getTime())
		{
			return false;
		}

		// In range
		return true;
	}

	// Set a Date
	_setDate(date: Date)
	{
		// Check date not in range
		if (!this._isDateInRange(date))
			date = this._Min;
		// Set data
		this._Value = this._parseDate(date);
		this._date = new Date(this._Value.getFullYear(), this._Value.getMonth(), 1);
	}

	// Parse Date
	_parseDate(date: any)
	{

		// If set now date
		if (typeof date === 'undefined' || date === null || date === 'now')
		{
			// Get date now
			date = new Date();
		}

		// If date is string
		else if (typeof date === 'string')
		{
			// Parse date string
			date = date.replace(/-/g, '/').match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/i);
			// If match
			if (date !== null)
			{
				let month_index = parseInt(date[2], 10) - 1;
				// Parse date
				date = new Date(date[3], month_index, date[1]);
				// Check if date does not exist
				if (!date || date.getMonth() !== month_index)
				{
					// Throw an error
					throw new Error('Calendar: Date does not exist.');
				}
			}
			// Can't parse string
			else
			{
				// Throw an error
				throw new Error('Calendar: Failed to parse date.');
			}
		}

		// If it is a number
		else if (typeof date === 'number')
		{
			// Get time from timestamp
			date = new Date(date);
		}

		// If it not a date
		else if (!(date instanceof Date))
		{
			// Throw an error
			throw new Error('Calendar: Invalid date.');
		}

		// Return date
		return new Date(date.getTime());
	}

	// Convert to date string
	_parseToDateString(date: Date, format: string)
	{
		return format.replace(/(MONTH|month|MMM|mmm|mm|m|MM|M|DAY|day|DDD|ddd|dd|d|DD|D|YYYY|yyyy)/g, (key: string) => this._dateStringParser(key, date));
	}

	// Get visible month
	_getVisibleMonth(date: Date)
	{
		// For date
		if (typeof date === 'undefined')
		{
			// Get saved date
			date = this._date;
		}
		else
		{
			date = this._parseDate(date);
		}

		// Get month's first day
		let first = new Date(date.getTime());
		first.setDate(1);

		// First day of the month index
		let firstDay = first.getDay() - this._options.firstDayOfTheWeek;
		if (firstDay < 0)
		{
			firstDay += 7;
		}

		// Get month's name

		let name = this._options.monthFormat.replace(/(MONTH|month|MMM|mmm|##|#|YYYY|yyyy)/g, (key: string) => this._dateStringParser(key, first));

		// Get visible days
		let days = this._getVisibleDates(date);
		let daysInMonth = new Date(first.getFullYear(), first.getMonth() + 1, 0).getDate();

		let current = -1;
		// If this is the month
		if (first.getFullYear() === this._Value.getYear() && first.getMonth() === this._Value.getMonth())
		{
			// Calculate current
			current = firstDay + this._Value.getDate() - 1;
		}

		// Return object
		return {
			monthName: this._dateStringParser('month', first),
			name: name,
			days: days,
			start: firstDay + 1,
			current: current,
			end: firstDay + daysInMonth
		};
	}

	// Get visible dates
	_getVisibleDates(date?: Date)
	{
		// For date
		if (typeof date === 'undefined')
		{
			// Get saved date
			date = this._date;
		}
		else
		{
			date = this._parseDate(date);
		}

		// Visible days array
		let dates = [];
		// Get first day of the month
		let first = new Date(date.getTime());
		first.setDate(1);
		first.setHours(0, 0, 0, 0);

		// Count days of previous month to show
		let previous = first.getDay() - this._options.firstDayOfTheWeek;
		if (previous < 0)
		{
			previous += 7;
		}
		// Set day to month's first
		let day = new Date(first.getTime());
		// Previous month's days
		while (previous > 0)
		{
			// Calculate previous day
			day.setDate(day.getDate() - 1);
			// Add page on frond of the list
			dates.unshift(new Date(day.getTime()));
			// Previous
			previous--;
		}

		// Set day to month's first
		day = new Date(first.getTime());
		// This month's days
		do
		{
			// Add page on back of the list
			dates.push(new Date(day.getTime()));
			// Calculate next day
			day.setDate(day.getDate() + 1);
			// Repeat until next month
		} while (day.getDate() !== 1);

		// Next month's days
		let next = 42 - dates.length;
		// Add days left
		while (next > 0)
		{
			// Add page on back of the list
			dates.push(new Date(day.getTime()));
			// Calculate next day
			day.setDate(day.getDate() + 1);
			// Next
			next--;
		}

		// Return days
		return dates;
	}

	// Create calendar
	_render()
	{
		this._initComponent('<div class="mdc-calendar app-list-group"><div class="mdc-calendar__head"></div>' +
			 '<table cellspacing="0" class="mdc-calendar__week-table"><tbody></tbody></table>' +
			 '<div role="separator" class="app-list-divider"></div>' +
			 '<h3 class="app-list-group__subheader"></h3>' +
			 '<table cellspacing="0" class="mdc-calendar__body"><tbody></tbody></table>' +
			 '</div>');

		this._target = this._root;

		this._elements.table = this._root.querySelector('.mdc-calendar__body');
		this._headtable = this._root.querySelector('.mdc-calendar__week-table');
		this._head = this._root.querySelector('.mdc-calendar__head');
		this._elements.body = this._elements.table.firstChild;
		this._mSubHeader = this._root.querySelector('.app-list-group__subheader');
		this._mSep = this._root.querySelector('.app-list-divider');

		let headerRow = this._headtable.insertRow(0);

		// Save instance
		let that = this;

		// Set created flag
		this._elements.created = true;

		this._elements.headLeft = new IconToggleButton({
			ParentNode: this._head,
			Class: 'mdc-calendar__head-left',
			FontImage: NP.FontImages.chevron_left,
			EvClick: () => this.previous()
		});

		this._elements.month = new Button({
			Class: "app-button--text",
			ParentNode: this._head,
			EvClick: () => this._setMode('List')
		});

		this._elements.headRight = new IconToggleButton({
			ParentNode: this._head,
			Class: 'mdc-calendar__head-right',
			FontImage: NP.FontImages.chevron_right,
			EvClick: () => this.next()
		});

		this._elements.days = [];

		let dayIndex = this._options.firstDayOfTheWeek - 1;
		for (let i = 0; i < 7; i++)
		{
			this._elements.days.push(headerRow.insertCell(i));
			this._elements.days[this._elements.days.length - 1].textContent = this._options.dayFormat.replace(/(DAY|day|DDD|ddd|DD|dd|D)/g, (key: string) => this._dayStringParser(key, dayIndex));
			dayIndex = dayIndex == 6 ? 0 : dayIndex + 1;
		}

		// Body rows
		this._elements.bodyRows = [];
		this._elements.bodyCols = [];
		// 6 rows
		for (let i = 0; i < 6; i++)
		{
			this._elements.bodyRows.push(document.createElement('tr'));
			this._elements.body.appendChild(this._elements.bodyRows[i]);
			// 7 days
			for (let j = 0; j < 7; j++)
			{
				this._elements.bodyCols.push(document.createElement('td'));
				this._elements.bodyRows[i].appendChild(this._elements.bodyCols[i * 7 + j]);
				this._elements.bodyCols[i * 7 + j].addEventListener('click', (function (index)
				{
					return function (event: Delegate)
					{
						that._eventFire_dateClick(event, that._active[index]);
					};
				})(i * 7 + j), false);
			}
		}

		this._listNode = NP.createNode(this._root, 'mdc-calendar__list-container');

		this._monthList = new ListBox({
			Items: NP.getCurrentCulture().ShortMonthNames.map((m: string, index: number) => ({
				Content: m,
				Value: index
			})),
			Class: 'mdc-calendar__month-list',
			EvItemClick: (o: object, e: ListBoxItemArgs) => {
				this._setMode('Calendar');
				let item = this._yearList.getSelectedItem();
				if (item)
				{
					let year = item.getValue();
					let month = e.Item.getValue()
					if (month >= 0)
					{
						this.setValue(new Date(year, month, moment(this._Value).day()));
					}
				}
			}
		});

		let endYear = moment(this._Max).year(),
			 items = [];

		for (let year = moment(this._Min).year(); year <= endYear; year++)
			items.push({
				HeaderText: year,
				Value: year
			});

		this._yearList = new Accordion({
			ParentNode: this._listNode,
			EvItemOpening: (s: Accordion, e: any) => e.Item.setContent(this._monthList),
			Items: items
		});

		NP.createNode(this._listNode, 'app-list-divider');

		this._cancelMonthBtn = new Button({
			ParentNode: this._listNode,
			RK: 'Cancel',
			EvClick: () => this._setMode('Calendar')
		});

		NP.hideNode(this._listNode);

		if (this._ParentNode)
			this.putToNode(this._ParentNode);
	}

	_setMode(value: string)
	{
		switch (value)
		{
			case 'Calendar':
				NP.hideNode(this._listNode);
				NP.showNodes([this._head, this._elements.table, this._headtable, this._mSubHeader, this._mSep]);
				break;
			case 'List':
				NP.hideNodes([this._head, this._elements.table, this._headtable, this._mSubHeader, this._mSep]);
				NP.showNode(this._listNode);
				break;
		}
	}

	// Select dates on calendar
	_selectDates(dates: any)
	{
		// Copy array instance
		dates = dates.slice();

		// Parse dates
		for (let i = 0; i < dates.length; i++)
		{
			dates[i] = this._parseDate(dates[i]);
			dates[i].setHours(0, 0, 0, 0);
			dates[i] = dates[i].getTime();
		}

		// Insert dates on array
		for (let i = dates.length - 1; i >= 0; i--)
		{
			// If not already selected
			if (this._selected.indexOf(dates[i]) < 0)
			{
				this._selected.push(dates[i]);
			}
		}
	}

	// Un-select dates on calendar
	_unselectDates(dates: any)
	{
		// Copy array instance
		dates = dates.slice();

		// Parse dates
		for (let i = 0; i < dates.length; i++)
		{
			dates[i] = this._parseDate(dates[i]);
			dates[i].setHours(0, 0, 0, 0);
			dates[i] = dates[i].getTime();
		}

		// Remove dates of the array
		let index;
		for (let i = dates.length - 1; i >= 0; i--)
		{
			// If selected
			index = this._selected.indexOf(dates[i]);
			if (index >= 0)
			{
				this._selected.splice(index, 1);
			}
		}
	}

	// Unselect all dates on calendar
	_unselectAllDates()
	{
		// While not empty
		while (this._selected.length)
		{
			this._selected.pop();
		}
	}

	// Update calendar
	_update()
	{
		// Get month info
		let month = this._getVisibleMonth(this._date);
		// Save data
		this._active = month.days.slice();
		// Update month name
		this._elements.month.setContent(month.name);
		this._mSubHeader.textContent = month.monthName;

		// Check zeros filling
		let prefix = '';
		if (this._options.zeroFill)
		{
			prefix = '0';
		}

		// Populate days

		for (let i = month.days.length - 1; i >= 0; i--)
		{
			let text = month.days[i].getDate();
			this._elements.bodyCols[i].textContent = (text < 10 ? prefix + text : text);

			// If date is selected
			if (this._selected.indexOf(month.days[i].getTime()) >= 0)
			{
				this._elements.bodyCols[i].className = 'mdc-calendar-selected';
			}
			else
			{
				this._elements.bodyCols[i].removeAttribute('class');
			}
		}

		// Previous month
		for (let i = 0; i < month.start - 1; i++)
		{
			this._elements.bodyCols[i].className = 'mdc-calendar-previous';
		}
		// Current day
		if (month.current >= 0)
		{
			if (this._elements.bodyCols[month.current].className.length > 0)
			{
				this._elements.bodyCols[month.current].className += ' mdc-calendar-current';
			}
			else
			{
				this._elements.bodyCols[month.current].className = 'mdc-calendar-current';
			}
		}
		// Next month
		for (let i = month.end; i < month.days.length; i++)
		{
			this._elements.bodyCols[i].className = 'mdc-calendar-next';
		}
	}

	_eventFire_dateClick(event: Delegate, date: Date)
	{
		this.setValue(date);
		this.EvDateChanged.fire(this);
	}

	// Goto a date
	setValue(date: Date)
	{
		this._setDate(date);
		this.refresh();
	}

	// Set min date
	min(date: Date)
	{
		// If value
		if (date)
		{
			// Set min date
			this._Min = this._parseDate(date);
		}
		// Disable
		else
		{
			this._Min = false;
		}

		// Refresh
		this.refresh();

		// Return
		return this;
	}

	// Set max date
	max(date: Date)
	{
		// If value
		if (date)
		{
			// Set max date
			this._Max = this._parseDate(date);
		}
		// Disable
		else
		{
			this._Max = false;
		}

		// Refresh
		this.refresh();

		// Return
		return this;
	}

	// Refresh
	// Safe _update
	refresh(date?: Date)
	{
		// If date provided
		if (typeof date !== 'undefined')
		{
			// If date is in range
			if (this._isDateInRange(date))
			{
				this._date = this._parseDate(date);
			}
		}

		// If calendar elements ready
		if (this._elements.created === true)
		{
			this._update();
		}

		// Return
		return this;
	}

	// Next month
	next(n?: number)
	{
		// Next number
		if (typeof n !== 'number')
		{
			n = 1;
		}

		// Calculate date
		let date = new Date(this._date.getFullYear(), this._date.getMonth() + n, 1);

		// If date is not in range
		if (!this._isDateInRange(date))
		{
			return this;
		}

		// Set date
		this._date = date;
		this.refresh();

		// Return
		return this;
	}

	// Next month
	previous(n?: number)
	{
		// Next number
		if (typeof n !== 'number')
		{
			n = 1;
		}

		// Calculate date
		let date = new Date(this._date.getFullYear(), this._date.getMonth() - n, (this._Value  || new Date()).getDate());

		// If date is not in range
		if (!this._isDateInRange(date))
		{
			return this;
		}

		// Set date
		this._date = date;
		this.refresh();

		// Return
		return this;
	}

	// Goto a date
	goto(date: Date)
	{
		this.refresh(date);

		// Return
		return this;
	}

	// Reset to the date
	reset()
	{
		this.refresh(this._Value);

		// Return
		return this;
	}

	// Select dates
	select(dates: Date[])
	{
		// If no arguments
		if (typeof dates === 'undefined')
		{
			// Return
			return this;
		}

		// If dates not array
		if (!(dates instanceof Array))
		{
			// Lets make it an array
			dates = [dates];
		}
		// Select dates
		this._selectDates(dates);
		// Refresh
		this.refresh();

		// Return
		return this;
	}

	// Unselect dates
	unselect(dates: Date[])
	{
		// If no arguments
		if (typeof dates === 'undefined')
		{
			// Return
			return this;
		}

		// If dates not array
		if (!(dates instanceof Array))
		{
			// Lets make it an array
			dates = [dates];
		}
		// Unselect dates
		this._unselectDates(dates);
		// Refresh
		this.refresh();

		// Return
		return this;
	}

	// Unselect all dates
	clearselect()
	{
		// Unselect all dates
		this._unselectAllDates();
		// Refresh
		this.refresh();

		// Return
		return this;
	}

	// Get selected dates
	getSelected(options?: any)
	{
		// Check if no options
		if (typeof options !== 'object')
		{
			options = {};
		}

		// Copy selected array
		let dates = this._selected.slice();

		// Options - Sort array
		if (options.sort)
		{
			if (options.sort === true)
			{
				dates.sort();
			}
			else if (typeof options.sort === 'string')
			{
				if (options.sort.toLowerCase() === 'asc')
				{
					dates.sort();
				}
				else if (options.sort.toLowerCase() === 'desc')
				{
					dates.sort();
					dates.reverse();
				}
			}
		}

		// Options - Data type
		if (options.type && typeof options.type === 'string')
		{
			let i;
			// Convert to date object
			if (options.type.toLowerCase() === 'date')
			{
				for (i = dates.length - 1; i >= 0; i--)
				{
					dates[i] = new Date(dates[i]);
				}
			}
			// If not a timestamp - convert to custom format
			else if (options.type.toLowerCase() !== 'timestamp')
			{
				for (i = dates.length - 1; i >= 0; i--)
				{
					dates[i] = this._parseToDateString(new Date(dates[i]), options.type);
				}
			}
		}

		// Return dates
		return dates;
	}

	// Check if date is selected
	isSelected(date: any)
	{
		// If no arguments or null
		if (typeof date === 'undefined' || date === null)
		{
			// Return
			return false;
		}

		// Parse date
		date = this._parseDate(date);
		date.setHours(0, 0, 0, 0);
		date = date.getTime();

		// If selected
		return this._selected.indexOf(date) >= 0;
	}

	// Check if date is visible in calendar
	isVisible(date: any)
	{
		// If no arguments or null
		if (typeof date === 'undefined' || date === null)
		{
			// Return
			return false;
		}

		// Parse date
		date = this._parseDate(date);
		date.setHours(0, 0, 0, 0);
		date = date.getTime();

		// Get visible dates
		let visible = this._getVisibleDates();
		// Check if date is inside visible dates
		return visible[0].getTime() <= date && visible[visible.length - 1].getTime() >= date;
	}

	// Check if date is in active month
	isInMonth(date: Date)
	{
		// If no arguments or null
		if (typeof date === 'undefined' || date === null)
		{
			// Return
			return false;
		}

		// Parse date and get month
		let month = this._parseDate(date);
		month.setHours(0, 0, 0, 0);
		month.setDate(1);

		// Parse active month date
		let active = this._parseDate(this._date);
		active.setHours(0, 0, 0, 0);
		active.setDate(1);

		// If same month
		return month.getTime() === active.getTime();
	}

	// Default function to handle date-string parsing
	_dateStringParser(key: string, date: Date)
	{
		let lang = NP.getCurrentCulture();
		switch (key)
		{
			case 'MONTH':
			case 'month':
				return lang.MonthNames[date.getMonth()];
			case 'MMM':
			case 'mmm':
				return lang.ShortMonthNames[date.getMonth()];
			case 'mm':
				return lang.MonthNames[date.getMonth()].substring(0, 2);
			case 'm':
				return lang.MonthNames[date.getMonth()].substring(0, 1);
			case 'MM':
				return (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1);
			case 'M':
				return date.getMonth() + 1;
			case '##':
				return (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1);
			case '#':
				return date.getMonth() + 1;
			case 'DAY':
			case 'day':
				return lang.DayNames[date.getDay()];
			case 'DDD':
			case 'ddd':
				return lang.DayNames[date.getDay()].substring(0, 3);
			case 'dd':
				return lang.DayNames[date.getDay()].substring(0, 2);
			case 'd':
				return lang.DayNames[date.getDay()].substring(0, 1);
			case 'DD':
				return (date.getDate() <= 9 ? '0' : '') + date.getDate();
			case 'D':
				return date.getDate();
			case 'YYYY':
			case 'yyyy':
				return date.getFullYear();
		}
	}

	// Default function to handle date-string parsing
	_dayStringParser(key: string, day: number)
	{
		let lang = NP.getCurrentCulture();
		switch (key)
		{
			case 'DAY':
			case 'day':
				return lang.DayNames[day];
			case 'DDD':
			case 'ddd':
				return lang.DayNames[day].substring(0, 3);
			case 'DD':
			case 'dd':
				return lang.ShortDayNames[day];
			case 'D':
				return lang.ShortDayNames[day].substring(0, 1);
		}
	}
}